import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u488987580/domains/monetizx.agency/hbuilds/source/MonetizX1start/src/components/ChatWidget.tsx");
;
import(/* webpackMode: "eager" */ "/home/u488987580/domains/monetizx.agency/hbuilds/source/MonetizX1start/src/styles/index.css");
